import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=43cb827e&"
import script from "./Folder.vue?vue&type=script&lang=js&"
export * from "./Folder.vue?vue&type=script&lang=js&"
import style0 from "./Folder.vue?vue&type=style&index=0&id=43cb827e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports